import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { AxiosResponse } from 'axios';
import { API } from 'network/api';
import { RizeUser } from 'types/common';

type Params = {
  country: string[];
  role: string[];
};

const useUserByRoleCountryQuery = (params?: Params) => {
  const queryParams = useMemo(
    () => ({
      country: params?.country?.join(','),
      role: params?.role?.join(','),
    }),
    [params],
  );
  const query = useQuery<AxiosResponse<RizeUser[]>>({
    queryKey: ['user-by-role-country', queryParams],
    queryFn: () => API.get('/user/users', { params: queryParams }),
  });

  const filterOptions = useMemo(() => {
    return query.data?.data?.map((user) => ({
      label: user.email,
      value: user.email,
    }));
  }, [query.data]);

  return { ...query, filterOptions };
};

export default useUserByRoleCountryQuery;
